import React from "react";
import { useNavigate } from "react-router-dom";
import { FiHeart, FiStar } from "react-icons/fi";
import RatingStars from "./RatingStars";

const ProductListItem = ({
  product,
  formatPrice,
  getAverageRating,
  reviews,
  categories,
  categoryItems,
}) => {
  const navigate = useNavigate();
  const avgRating = getAverageRating(product._id);
  const reviewCount = reviews.filter((r) => r.productId === product._id).length;
  const category =
    categories.find((cat) => cat._id === product?.category)?.name ||
    product?.category;
  const subCategory =
    categoryItems.find((sub) => sub._id === product?.subCategory)?.name ||
    product?.subCategory;

  // Calculate discount if originalPrice is greater than price
  const discount =
    product.originalPrice > product.price
      ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
      : 0;

  return (
    <div
      className="flex flex-col sm:flex-row gap-4 p-4 bg-white border rounded-lg hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => navigate(`/product/${product._id}`)}
    >
      <div className="relative w-full h-48 sm:w-32 sm:h-32 bg-gray-100 rounded overflow-hidden flex-shrink-0 mx-auto sm:mx-0">
        <img
          src={product.image[0] || "/placeholder-product.jpg"}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {discount > 0 && (
          <div className="absolute top-2 left-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded">
            {discount}% OFF
          </div>
        )}
      </div>

      <div className="flex-1 text-center sm:text-left">
        <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start">
          <div className="mb-2 sm:mb-0">
            <h3 className="font-medium mb-1 line-clamp-2">{product.name}</h3>
            <p className="text-xs text-gray-500">
              {category} - {subCategory}
            </p>
          </div>
          <button
            className="p-1 text-gray-500 hover:text-black flex-shrink-0"
            onClick={(e) => {
              e.stopPropagation();
              // Add to wishlist
            }}
          >
            <FiHeart />
          </button>
        </div>

        <div className="flex items-center justify-center sm:justify-start mb-2">
          <RatingStars rating={avgRating} />
          <span className="text-xs text-gray-500 ml-1">({reviewCount})</span>
        </div>

        <div className="flex flex-wrap items-center justify-center sm:justify-between gap-2 mt-auto">
          <div>
            <span className="font-bold text-lg sm:text-base">{formatPrice(product.price)}</span>
            {product.originalPrice > product.price && (
              <span className="text-xs text-gray-500 line-through ml-1">
                {formatPrice(product.originalPrice)}
              </span>
            )}
          </div>

          {product.colors?.length > 0 && (
            <div className="flex gap-1">
              {product.colors.slice(0, 5).map((color) => (
                <div
                  key={color}
                  className="w-4 h-4 rounded-full border border-gray-200"
                  style={{ backgroundColor: color }}
                  title={color}
                />
              ))}
              {product.colors.length > 5 && (
                <div className="text-xs text-gray-500">
                  +{product.colors.length - 5}
                </div>
              )}
            </div>
          )}

          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/product/${product._id}`);
            }}
            className="text-xs px-3 py-1 bg-black text-white rounded hover:bg-gray-800"
          >
            View Details
          </button>
        </div>

        {product.materials?.length > 0 && (
          <div className="mt-2 text-center sm:text-left">
            <span className="text-xs text-gray-500">Materials: </span>
            <span className="text-xs">{product.materials.join(", ")}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductListItem;